import { frontendURL } from '../../../helper/URLHelper';
import TasksIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tasks'),
    component: TasksIndex,
    name: 'tasks_index',
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
